<template>
	<div>
		<page-title-bar></page-title-bar>
		<app-section-loader :status="loader"></app-section-loader>

  	<v-container fluid grid-list-xl py-0>
			<v-layout row wrap>
				<app-card
					:fullBlock="true"
					colClasses="xs12 xs12 xs12 xs12 xs12 xs12 xs12 xs12 xs12"
				>

					<app-card>
            Volgorde en opmaak nieuwe gebruikers/kamers moet vanuit het windows programma gebeuren!
					</app-card>

					<v-card-title>Medewerkers / Ruimtes
						<v-spacer></v-spacer>
					</v-card-title>
					<v-data-table
						v-bind:headers="headers"
						v-bind:items="items" 
							:rows-per-page-items="[-1]"
					>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.UserName }}</td>
							<td>{{ props.item.KindUser }}</td>
							<td><v-checkbox v-model="props.item.IsHideScheduler" :disabled="true"></v-checkbox></td>
							<td><v-checkbox v-model="props.item.IsActive" :disabled="true"></v-checkbox></td>
							<td>{{ props.item.NumOrder }}</td>
							<td class="text-xs-center"><v-btn icon  @click="editRec (props.item)"><v-icon small>edit</v-icon></v-btn></td>
						</template>
						<template slot="pageText" slot-scope="{ pageStart, pageStop }">
							From {{ pageStart }} to {{ pageStop }}
						</template>
					</v-data-table>
				</app-card>

			</v-layout>
  	</v-container>
	</div>
</template>

<script>
import myHttpApi from "../../api/myHttpApi";
import router from '../../router';
import Vue from 'vue';

export default {
  data() {
    return {
			dialog2: false,
			currentRec : '',
			loader: true,
      max25chars: v => v.length <= 25 || "Input too long!",
      tmp: "",
      search: "",
			pagination: {},
      headers: [
        { text: "Medewerker / Ruimte", value: "UserName" },
				{ text: "Soort", value: "KindUser" },
				{ text: "Verberg in agenda", value: "IsVisibleScheduler", width: "30px" },
				{ text: "Aktief", value: "IsActive", width: "30px" },
				{ text: "Volgorde", value: "NumOrder", width: "30px" },
				{ text: "", value: "Modify", width: "30px" }
      ],
			items: []
    };
  },
  mounted() {
		this.search = Vue.$lastSearchCustomers;
		console.log (this.search);
		this.getTablesData();
  },
  methods: {
    getTablesData() {
			myHttpApi

		const searchRec = {Search: "", Extra: ""}
		myHttpApi.post( 'BOUser/Search', searchRec)
        .then(response => {
					this.loader = false;
					this.items = [];
					this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        });
		},
		 editRec(rec){
			 this.currentRec = rec;
			 router.push({name:'userdet', params: {id: rec.UserID,  isNew: false } });
		},
  },
  watch: {
    search(after, before) {
            this.getTablesData();
		},
		kindrec(newId, oldId) {
       this.getTablesData();
    }
	}
};
</script>
